function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const PencilIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C14.9 0 16 1.1 16 2.5c0 .6-.2 1.1-.5 1.5l-1 1L11 1.5l1-1c.4-.3.9-.5 1.5-.5zM1 11.5L0 16l4.5-1 9.2-9.2-3.5-3.5L1 11.5zm10.2-5.8l-7 7-.9-.9 7-7 .9.9z"
  }));
};
export default PencilIcon;